/*------------------------------------*\
    #IMG SWAP GALLERy
\*------------------------------------*/

/**
 * function for a gallery swapping out thumbails with the large image.
 */


WW.thumbnailGallery = function($) {
    'use strict';
    let currentImage = 1;

    function imgLoaded(el) {
        setTimeout(() => {
            el.animate({opacity : 1}, 300);
        }, 200);
    }

    function loadImage($parent, currentItemImage) {
      const $imageContainer = $parent.find('.js-swap-img-gallery__lg');

      $imageContainer.animate({
          opacity : 0
      }, 300, () => {
          $imageContainer.attr('src', currentItemImage).load(imgLoaded($imageContainer));
      });
    }

    function toggleImage($that) {
        const toggleNext = $that.hasClass('js-swap-img-gallery__toggle--next');
        const $parent = $that.closest('.js-swap-img-gallery');
        const $list = $parent.find('.js-swap-img-gallery__list');
        const $items = $parent.find('.js-swap-img-gallery__item');
        const amountOfItems = $items.length;

        if (toggleNext) {
          if (currentImage == amountOfItems) return;
          currentImage += 1;
        } else {
          if (currentImage == 1) return;
          currentImage -= 1;
        }

        const $currentItem = $list.find(`.js-swap-img-gallery__item:nth-child(${currentImage})`);
        const currentItemImage = $currentItem.find('.js-single-sm-img').data('large-src');
        loadImage($parent, currentItemImage, amountOfItems);
    }

    $('.js-swap-img-gallery__toggle').on('click', function(event) {
      event.preventDefault();
      toggleImage($(this));
    });

    return this;
};

// add the following to main.js: .thumbnailGallery($)


